export default __webpack_public_path__ + "static/media/closed-bin.a6fd2950.png";